export const versions = {
  TW: 'tw',
  CN: 'cn',
  EN: 'en',
}
